import { forwardRef, type Ref, type SVGProps } from "react";
const IconManufacturedFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fillRule="evenodd"
      d="M4.821 4.212A2 2 0 0 1 6.66 3h18.682a2 2 0 0 1 1.838 1.212l2.143 5A2 2 0 0 1 27.484 12H27v9a2 2 0 0 1-2 2v2a1 1 0 1 1-2 0v-2h-2v2a1 1 0 1 1-2 0v-2H7a2 2 0 0 1-2-2v-9h-.483a2 2 0 0 1-1.839-2.788zM10 16a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v5h-5z"
      clipRule="evenodd"
    />
    <path d="M9 24a1 1 0 1 0 0 2h7a1 1 0 1 0 0-2z" />
    <path d="M7 28a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1" />
  </svg>
);
const ForwardRef = forwardRef(IconManufacturedFilledSVG);
ForwardRef.displayName = "IconManufacturedFilled";
export { ForwardRef as IconManufacturedFilled };
